<template>
  <tile class="opc-zmone">
    <foldable v-if="showFoldable" v-model="isExpanded" :title="title" :arrow="canExpand" :edit="canExpand" :isRemoveWrapAriaLabelledby="true">
      <div slot="head" class="opc-zm-base-card__head">
        <div class="opc-zm-base-card__head-left">
          <img class="opc-zm-base-card__logo" :src="logo" :alt="title" />
        </div>
        <div class="opc-zm-base-card__head-right">
          <h2 class="opc-zm-base-card__name text-capitalize">
            {{ title }}
            <i class="zm-icon-success main-icon" aria-hidden="true"></i>
          </h2>
          <div class="opc-zm-base-card__view-detail-button">
            <zm-button v-if="isExpanded" class="opc-zmone__link" type="link" @click="handleExploreOtherPlansClick">
              {{ $t('billing.zone.explore_other_plans_edit') }}
            </zm-button>
          </div>
          <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
            {{
              $t('billing.zone.desc1', [
                form.selectedNumber,
                $money(formPlan ? formPlan.amount : 0),
                $t(`billing.common.per_billing_cycle_user.${form.billingCycle}`),
              ])
            }}
          </div>
        </div>
      </div>
      <div class="opc-zmone__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form">
          <zm-form-item>
            <p class="opc-zmone__form-label" slot="label">
              {{ $t('billing.zone.select_license') }}
              <zm-tooltip class="item" aria-label="Learn more about Select the number of users" placement="top">
                <span class="opc-zone__tip" slot="content" v-html="$t('billing.zone.attendee_info_edit')"></span>
                <i class="zm-icon-info-outline main-icon"
                  @click="() => $tracking.buyInteraction(trackingPlanName + ' options', 'number of users - tooltip')"></i>
              </zm-tooltip>
            </p>
            <license-tip :type="form.category" :number="form.selectedNumber">
              <zm-button class="opc-zmone__link" type="link" v-if="showExploreLink" @click="handleExploreOtherPlansClick">{{
                $t('billing.zone.explore_other_plans') }}</zm-button>
            </license-tip>
            <InputNumberWithPopover class="opc-zmone__quantity-selector" v-model="form.selectedNumber" size="large"
              controls-position="both" :min="minHost" :max="maxHost" @change="submitLicenseChange"
              :label="`${title} Select the number of users`" />
          </zm-form-item>
          <zm-form-item :label="$t('billing.select_billing_cycle')">
            <zm-radio-group
              v-model="form.billingCycle"
              class="opc-card-radio"
              :aria-label="`${title} Billing Cycle`"
              @change="submitForm"
            >
              <zm-tooltip v-for="plan in currentPlans" :key="plan.billing_cycle"
                :disabled="!billingCycleDisabled(plan.billing_cycle)">
                <div slot="content" v-html="billingCycleDisabled(plan.billing_cycle) || ''" />
                <zm-radio :label="plan.billing_cycle" :disabled="!!billingCycleDisabled(plan.billing_cycle)"
                  class="opc-zmone__radio">
                  <p class="opc-zmone__radio-title text-capitalize">{{ $t(`billing.billing_cycle.${plan.billing_cycle}`) }}</p>
                  <p class="opc-product-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(plan)">
                    <span v-for="(value, key, index) in getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true })"
                          :key="index"
                          :class="[`opc-product-price-container__${key}`, useSmallSize(value) ? 'opc-product-price-container__small' : '']"
                          :style="value.symbol && value.place === 'end' ? { order: 1 } : {}"
                          aria-hidden="true"
                          >
                      {{ value.symbol ? value.symbol: value }}
                    </span>
                  </p>
                  <p class="opc-zmone__radio-price-unit opc-price-bill-text">
                    <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount)"></span><priceVATTip />
                  </p>
                </zm-radio>
              </zm-tooltip>
            </zm-radio-group>
          </zm-form-item>
          <preview-payment />
        </zm-form>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import logo from '@/assets/plans/icon_ZM.svg';
import {
  A_LINK_TAG_NAME,
  A_LINK_TEXT_CONTENT,
  limitBillingCycleWithBaseZoneTypes,
  BILLING_CYCLE,
  planTypes,
  maxBizAndBizPlusLicenseCount
} from '@/common/constants';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import FullComparisonDialog from '@/plans/ZOOM_MEETING/dialog/full-comparison-dialog';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { debounce, groupBy, throttle, get } from 'lodash';
import { getCategoryNameI18nKey } from '@/plans/ZOOM_MEETING/common/utils';
import plansMixin from '@/plans/mx/plan';
import { isEmptyVal } from '@/utils';
import LicenseTip from '../license-tip.vue';
import saveMixins from '../save-mixins';
import { getPlanUnitWithCycle } from '@/common/product-unit';
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import PreviewPayment from '@/views/checkout/payment/preview-payment.vue';


export default {
  mixins: [plansMixin, saveMixins, discountedMonthPrice],
  data() {
    return {
      logo,
      isExpanded: true,
      form: {
        category: 'pro',
        billingCycle: 'annual',
        selectedNumber: 1,
      },
      oldPlanCode: '',
      BILLING_CYCLE: BILLING_CYCLE,
      fullComparisonDialog: new ServiceConfirm(FullComparisonDialog, this.$store),
      isInitUpdateForm: false,
      canExpand: true,
      showFoldable: true
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters(['getSelectedPlans', 'getUserCurrentSubscriptions']),
    title() {
      return this.$t(this.formPlan?.planNameKey)
    },
    showExploreLink() {
      return this.form.selectedNumber < maxBizAndBizPlusLicenseCount;
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_MEETING);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    currentPlans() {
      return this.zonePlanGroupByCategory[this.form.category];
    },
    annualPriceM() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount * 12 : 0;
    },
    annalPriceSave() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (this.annualPriceM && annualPlan) {
        return this.annualPriceM - annualPlan.amount;
      }
      return 0;
    },
    saveLabel() {
      return {
        [BILLING_CYCLE.MONTHLY]: '',
        [BILLING_CYCLE.ANNUAL]: this.annalPriceSave > 0
          ? `${this.$money(this.annalPriceSave)} ${this.$t('billing.annual_save')}`
          : '',
      };
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.form.billingCycle,
      );
    },
    trackingPlanName() {
      return this.$t(`Zoom One ${this.form?.category}`);
    },
    minHost() {
      return this.formPlan ? this.formPlan.min : 1;
    },
    maxHost() {
      return this.formPlan ? this.formPlan.max : 99;
    },
    annualAddonPlans() {
      const newLimit = [];
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.concat(newLimit).includes(item.type) &&
        item.billing_cycle === BILLING_CYCLE.ANNUAL
      ));
    },
  },
  created() {
    this.updateForm(true);
  },
  methods: {
    ...mapActions({
      switchSelectPlan: 'switchSelectPlan',
    }),
    ...mapMutations(['updateSelectPlan', 'savePersist', 'setUpdateBasePlan']),
    // sync shopping cart plan to local form state
    updateForm(isInitUpdateForm = false) {
      const shoppingCartPlan = this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = shoppingCartPlan.cartInfo.selected_number;
        this.oldPlanCode = shoppingCartPlan.plan_code;
      }

      this.isInitUpdateForm = isInitUpdateForm;
    },
    submitLicenseChange: throttle(function (v) {
      this.$nextTick(() => {
        if (!this.formPlan) {
          return;
        }
        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }
        this.updateSelectPlan({
          ...this.formPlan,
          cartInfo: {
            selected_number: this.form.selectedNumber,
          },
        });
        this.updateForm();
      });
    }, 500),
    submitForm: throttle(function (v) {
      this.$nextTick(() => {
        if (!this.formPlan) {
          return;
        }

        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }

        if (this.formPlan.plan_code === this.oldPlanCode) {
          this.updateSelectPlan({
            ...this.formPlan,
            cartInfo: {
              selected_number: this.form.selectedNumber,
            },
          });
        } else {
          this.switchSelectPlan([
            this.oldPlanCode,
            this.formPlan.plan_code,
            {
              selected_number: this.form.selectedNumber,
            },
          ]);
        }
        this.updateForm();
      });
    }, 200),
    async handleExploreOtherPlansClick() {
      this.$tracking.buyInteraction('explore other plans', `${this.trackingPlanName} - explore other plans`);
      await this.showFullComparisonDialog();
    },
    async showFullComparisonDialog() {
      this.$tracking.buyInteraction('product details', 'full plan comparison - impression');
      await this.fullComparisonDialog.confirm();
      this.$nextTick(() => this.updateForm());
    },
    getCategoryName(category) {
      return this.$t(getCategoryNameI18nKey(category));
    },
    onLicenseTipsClick(event) {
      if (event?.target?.tagName === A_LINK_TAG_NAME && event?.target?.textContent === A_LINK_TEXT_CONTENT.FORM) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - 'you are not able to make this change to  your account mid-contract' - contact form`);
        return;
      }
      this.doReturnPlanManagementTracking(event, 'adjust the add-on product and base product license quantity');
    },
    onCycleClick(event) {
      this.doReturnPlanManagementTracking(event, 'update to monthly subscription first');
    },
    doReturnPlanManagementTracking(event, msg) {
      if (event?.target?.tagName === A_LINK_TAG_NAME && event?.target?.textContent === A_LINK_TEXT_CONTENT.RETURN_PLAN_MANAGEMENT) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - ${msg} - return to plan management`);
      }
    },
    getBillingCycleDisabledDesc(billingCycle) {
      if (this.form.billingCycle === billingCycle && billingCycle === BILLING_CYCLE.ANNUAL) {
        return false;
      }
      const planGroupByType = groupBy(this.annualAddonPlans, 'type');
      const typeNames = Object.keys(planGroupByType).map(type => {
        const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
      if (billingCycle === BILLING_CYCLE.MONTHLY && this.annualAddonPlans.length) {
        return this.$t('billing.planform.monthly_base_disable_tooltip', [typeNames.join(','), this.$t('billing.planform.title.zoom_meeting_zoomonenew')]);
      }
      return false;
    },
    billingCycleDisabled(billingCycle) {
      return this.getBillingCycleDisabledDesc(billingCycle);
    },
    getPlanUnitWithCycle(cycle) {
      return getPlanUnitWithCycle(cycle);
    },
  },
  components: {
    PreviewPayment,
    Foldable,
    Tile,
    InputNumberWithPopover,
    LicenseTip,
  },
  watch: {
    isExpanded: {
      handler(val) {
        this.$tracking.buyInteraction(
          'product details accordion',
          `${this.trackingPlanName} - ${val ? 'expand' : 'collapse'}`,
        );
      },
    },
    'form.billingCycle': {
      immediate: true,
      handler: debounce(function (val) {
        !this.isInitUpdateForm && this.$tracking.buyInteraction(
          'billing cycle',
          `${this.trackingPlanName} - toggled billed ${val}`,
        );
      }, 500),
    },
    'form.selectedNumber': {
      handler: debounce(function (newLicense, oldLicense) {
        if (this.formPlan) {
          // event tracking
          !this.isInitUpdateForm && this.$tracking.buyInteraction('number of hosts',
            `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`);
        }
      }, 500),
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-zmone {
  .main-icon {
    color: $theme-color;
  }

  .reason-tips {
    margin-top: 12px;

    .zm-alert__description {
      display: flex;
      align-items: center;
    }

    p {
      margin-left: 13px;
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #515079;
    }
  }

  &__link.zm-button--link {
    margin-left: 5px;
    font-weight: 700 !important;
    color: $theme-color;
    padding: 0;
  }

  &__quantity-selector {
    margin-top: 12px;
    @include media(mobile) {
      margin-top: 12px;
    }
  }

  &__desc {
    padding-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: #00053d;
  }

  &__main {
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid #dfdfe4;
    @include media(mobile) {
      margin-top: 16px;
      padding-top: 16px;
    }
  }

  &__desc {
    position: relative;
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    color: #515079;
    padding: 0;
    margin: 0;
    @include media(mobile) {
      font-size: 14px;
    }

    &.is-warning {
      padding: 8px 12px 8px 40px;
      background: #FEF7D9;
      border-radius: 8px;

      &::before {
        content: '';
        background-image: url('../../../assets/Alert.svg');
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: calc(50% - 8px);
        left: 12px;
      }
    }
  }

  &__form-label {
    margin: 0;
    padding: 0;
    color: #00031F;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 27px;
    @include media(mobile) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  .opc-card-radio {
    margin-top: 8px;

    .opc-zmone__radio {
      width: 100%;

      .zm-radio__wrap {
        width: 100%;
      }
    }
  }

  .opc-card-radio &__radio {
    .zm-radio__label--inner {
      width: 100%;
      // min-height: 136px;
      padding: 16px;
    }

    &-title {
      color: #00053D;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      margin: 0;
      display: flex;
      flex-wrap: wrap;

      .opc-price-save-count {
        margin-left: 4px;
      }
    }

    .zm-radio__label {
      &.is-disabled {
        .opc-zmone__radio-title, .opc-zmone__radio-price, .opc-zmone__radio-price-unit {
          color: #9191A4 !important;
        }
      }
    }

    &-save-label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      color: #4a7d5c;
      min-width: 1px;
      min-height: 21px;
    }

    &-price {
      color: #00053D;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 33px;

      &-unit {
        color: #666487;
        font-size: 12px;
        font-style: normal;
        font-weight: 450;
        line-height: 120%;
      }

      &-delete {
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        text-decoration-line: line-through;
        color: #515079;
      }
    }
  }
}</style>

<style lang="scss">.opc-zone__tip b {
  font-weight: bold !important;
}</style>
